import { useDispatch, useSelector } from 'react-redux';
import { selectContractorToolsLimit } from '../../../../selectors/application';
import { setContractorToolsCoverage, setCheckedEndorsement } from '../../../../actions/application';
import { formatCurrency } from '../../../../helpers/formatNumber';
import { EndorsementKey } from '../../types';
import EndorsementSummaryCardLayout from '../../../Summary/Endorsements/EndorsementSummaryCardLayout';

const ContractorToolsSummaryCard = ({ value }: { value: any }) => {
  const dispatch = useDispatch();
  const contractorToolsLimit = useSelector(selectContractorToolsLimit);

  const coverageInfo = [{ coverage: 'Limit', limit: formatCurrency(Number(contractorToolsLimit)) }];

  const handleRemove = () => {
    dispatch(setCheckedEndorsement(EndorsementKey.ContractorsInstallationAndTools, false));
    dispatch(setContractorToolsCoverage(null));
  };

  const handleRestore = () => {
    dispatch(setCheckedEndorsement(EndorsementKey.ContractorsInstallationAndTools, true));
    dispatch(setContractorToolsCoverage(value));
  };

  return (
    <EndorsementSummaryCardLayout
      label="Contractor Tools Coverage"
      coverageInfo={coverageInfo}
      onRemove={handleRemove}
      onRestore={handleRestore}
    />
  );
};

export default ContractorToolsSummaryCard;
